import { IconArchive as TablerIconArchive } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconArchive = /*#__PURE__*/ createOutlineIcon(TablerIconArchive, 'IconArchive');
